import React from "react";
const DevContext = React.createContext({});
const useDevService = () => {
  const service = React.useContext(DevContext);
  const serviceRef = React.useRef(service);
  serviceRef.current = service;
  return React.useCallback(() => serviceRef.current, []);
};
const useTrackRender = (componentName) => React.useContext(DevContext)?.trackRender?.(componentName);
const useDevGiphyRequestService = () => React.useContext(DevContext)?.giphyRequestService;
const useDevAiRequestService = () => React.useContext(DevContext)?.aiRequestService;
const useDevShapeService = () => React.useContext(DevContext)?.shapeService;
const useDevConnectionState = () => {
  const [defaultState] = React.useState({
    type: "NO_MODIFICATION"
  });
  return React.useContext(DevContext)?.connectionState ?? defaultState;
};
const useDevLogBi = () => {
  return React.useContext(DevContext)?.logBi ?? void 0;
};
const useDevPmNodeAttrs = () => React.useContext(DevContext)?.pmNodeAttrs ?? void 0;
const useDevPickMedia = () => React.useContext(DevContext)?.pickMedia ?? void 0;
const useDevVerticalEmbedItems = () => React.useContext(DevContext)?.fetchVerticalEmbedItemsFromDevContext ?? void 0;
const useDevVerticalEmbedItem = () => React.useContext(DevContext)?.fetchVerticalEmbedItemFromDevContext ?? void 0;
const useMockInlineAiResponseChunks = () => React.useContext(DevContext)?.mockInlineAiResponseChunks ?? void 0;
export {
  DevContext,
  useDevAiRequestService,
  useDevConnectionState,
  useDevGiphyRequestService,
  useDevLogBi,
  useDevPickMedia,
  useDevPmNodeAttrs,
  useDevService,
  useDevShapeService,
  useDevVerticalEmbedItem,
  useDevVerticalEmbedItems,
  useMockInlineAiResponseChunks,
  useTrackRender
};
//# sourceMappingURL=dev-context.js.map
